import MoreIcon from "@/common/images/icons/moreIcon.svg?react";
import "./MoreTagsButton.scss";
import { Tooltip } from "components/tooltip/Tooltip";
import { useRef } from "react";
import { Button } from "components/buttons/Button";
import { PulseCircle } from "components/UI/PulseCircle";

export const MoreTagsButton = (props: {
  onClick: () => void;
  isShowTagFeedbackTooltip: boolean;
  onDismissTagFeedbackTooltip: (forceClose: boolean) => void;
}): JSX.Element => {
  const btnRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <button className="more moreTags" onClick={props.onClick} aria-label="show more tags button" ref={btnRef}>
        <MoreIcon />
        {props.isShowTagFeedbackTooltip && <PulseCircle />}
      </button>
      {props.isShowTagFeedbackTooltip && (
        <Tooltip
          size="xl"
          position="topRight"
          anchorEl={btnRef.current}
          active={props.isShowTagFeedbackTooltip}
          className="TagFeedbackNotice"
          onClose={() => props.onDismissTagFeedbackTooltip(true)}
        >
          <span className="TagFeedbackNotice-Message">Something not right with these tags? Tap to give feedback.</span>
          <Button variant="primary" size="xs" onClick={() => props.onDismissTagFeedbackTooltip(false)}>Got it</Button>
        </Tooltip>
      )}
    </>
  );
};
